import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "on-focus__recent-queries-container q-text-dark"
}
const _hoisted_2 = { class: "on-focus__recent-queries-content q-text-dark" }

import QueriesContainer from '../Queries/QueriesContainer.vue'
import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";
import { onMounted, inject} from "vue";
import {storeToRefs} from "pinia";
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRecentQueriesContainer',
  setup(__props) {

const userRecentQueriesStore = useUserRecentQueriesStore()
const {hasRecentQueries} = storeToRefs(userRecentQueriesStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

onMounted(() => {
  userRecentQueriesStore.getQueries()
})


return (_ctx: any,_cache: any) => {
  return (_unref(hasRecentQueries))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(QueriesContainer, {
            "can-remove": true,
            queries: _unref(userRecentQueriesStore).recentQueries,
            "queries-header": _unref(SmartSearchTranslations).userRecentQueries.header
          }, null, 8, ["queries", "queries-header"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})